export const usePriceDiff = (price: number, basePrice?: number) => {
  const priceDiff = basePrice ? price - basePrice : null;

  let sign = '';
  if (priceDiff && priceDiff != 0) {
    sign = priceDiff > 0 ? '+' : '-';
  }

  return { priceDiff, sign };
};
